// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","highlightedRanking":"iEqTzu8vBgWJKo_jx742E","starIcon":"_1MJzlbNmCVjoM-RV45PT8P","fadedLogo":"_2vEh8V0ZTQwwAt9yHLXPRz"};